import axios from 'axios';

export type FieldPathSegment = string | number;

/**
 * Builds a Spring-style validation field path from ordered segments, matching
 * the keys returned by `extractFieldErrors`. Numeric segments become bracketed
 * list indices; string segments are dot-joined.
 *
 * buildFieldPath('weeks', 0, 'groups', 1, 'name') => 'weeks[0].groups[1].name'
 */
export function buildFieldPath(...segments: FieldPathSegment[]): string {
  return segments.reduce<string>((path, segment) => {
    if (typeof segment === 'number') return `${path}[${segment}]`;
    return path ? `${path}.${segment}` : segment;
  }, '');
}

export function extractFieldErrors(error: unknown): Record<string, string> {
  const errors: Record<string, string> = {};
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as
      | { errors?: Array<{ field?: string; defaultMessage?: string }> }
      | undefined;
    if (data?.errors) {
      for (const e of data.errors) {
        if (e.field && e.defaultMessage) {
          errors[e.field] = e.defaultMessage;
        }
      }
    }
  }
  return errors;
}
